import React from "react";
import { Route } from "react-router-dom";
import Offering from "../../../containers/modules/purchasing/offering";
import AccessControl from "../../../components/utilities/Class/AccessControl";

export default function OfferingRoutes(props) {
  const { authUser } = props;
  return (
    <Route
      path="offering"
      index
      element={
        <AccessControl
          name={"Offering List"}
          auth={authUser}
          component={() => <Offering auth={authUser} />}
        />
      }
    ></Route>
  );
}
